import { useQuery } from '@tanstack/react-query';
import { fetchMonitoringOverview } from '../services/dmMonitoringOverview';
import { MONITORING_OVERVIEW_KEY } from './queryKeys';

const REFRESH_MS = 60_000;

export function useMonitoringOverview() {
    const { data, isLoading, isFetching, isError, refetch } = useQuery({
        queryKey: MONITORING_OVERVIEW_KEY,
        queryFn: fetchMonitoringOverview,
        staleTime: REFRESH_MS,
        refetchInterval: REFRESH_MS,
        refetchOnWindowFocus: true
    });
    return {
        overview: data ?? null,
        isLoading,
        isFetching,
        // With data cached this is a failed poll: callers keep showing the last data.
        isError,
        retry: refetch
    };
}
